module.exports = __webpack_public_path__ + "img/Android2.37d22e70.png";